import React from 'react'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'
import { Button } from 'antd'
import { DownOutlined, UpOutlined } from '@ant-design/icons'

import { bangkokClock } from './journeyTime'
import { lineMessageKey, wordsFor } from './journeyWords'
import { ChatLine, ChatList, ChatText, Clock, Muted } from './journeyStyles'

const ChatToggle = ({ open, onToggle }) => {
  const { t } = useTranslation('inquiries')
  return (
    <Button
      type='link'
      size='small'
      style={{ padding: 0 }}
      aria-expanded={open}
      icon={open ? <UpOutlined /> : <DownOutlined />}
      iconPosition='end'
      onClick={onToggle}
    >
      {open ? t('orderJourney.hideChat') : t('orderJourney.showChat')}
    </Button>
  )
}

const ChatMessages = ({ chat, count, journey, lang }) => {
  const { t } = useTranslation('inquiries')
  return (
    <ChatList>
      {count > chat.length && (
        <li>
          <Muted>{t('orderJourney.chatCut', { shown: chat.length, count })}</Muted>
        </li>
      )}
      {chat.map((message, index) => (
        <ChatLine key={`${message.at}-${index}`}>
          <Clock>{bangkokClock(message.at)}</Clock>
          {message.text ? (
            <ChatText>{message.text}</ChatText>
          ) : (
            <Muted>{wordsFor(journey, lineMessageKey(message.message_type), lang)}</Muted>
          )}
        </ChatLine>
      ))}
    </ChatList>
  )
}

ChatToggle.propTypes = {
  open: PropTypes.bool.isRequired,
  onToggle: PropTypes.func.isRequired
}

ChatMessages.propTypes = {
  chat: PropTypes.arrayOf(PropTypes.object).isRequired,
  count: PropTypes.number.isRequired,
  journey: PropTypes.object.isRequired,
  lang: PropTypes.string.isRequired
}

export { ChatToggle, ChatMessages }
